export default __webpack_public_path__ + "static/media/time-of-day-example.4893e7f1.png";